<template>
  <div>
    <el-dialog
      title="驳回原因"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
    >
      <el-form size="small" class="form-centent">
        <div class="row">
          <div class="col">
            <div class="tip">请输入驳回商品标签的原因</div>
            <div class="value">
              <el-input
                maxlength="30"
                v-model="formIn.remark"
                placeholder="请输入30字以内的驳回原因"
              />
            </div>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="doUpdate()">驳回</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import _ from "lodash";
import { getLabelInfo, checkLabelInfo } from "@/api/platform/index";

export default {
  components: {},
  props: {},
  computed: {
    headers: function () {
      return {
        Authorization: "Bearer " + getToken(),
      };
    },
  },
  data() {
    return {
      dialogVisible: false,
      rowData: null,

      formIn: {
        remark: "",
      },
    };
  },
  methods: {
    doUpdate() {
      if (!this.formIn.remark) {
        this.$message.error("请输入驳回原因");
        return;
      }

      let data = {
        id: this.rowData.id,
        remark: this.formIn.remark,
        checkStatus: 0,
      };
      _.merge(data, this.formIn);

      checkLabelInfo(data).then((res) => {
        if (res) {
          this.$message.success("更新价格成功");
          this.$emit("updateSuccess");
          this.handleClose();
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
    },
    init() {
      //
    },
    clear() {
      this.rowData = null;
      for (let key in this.formIn) {
        this.formIn[key] = "";
      }
    },
    open(item) {
      this.clear();
      this.dialogVisible = true;
      this.rowData = _.cloneDeep(item);
    },
  },
};
</script>
<style scoped lang="scss">
.form-centent {
  .row {
    display: flex;

    &:not(:first-child) {
      margin-top: 24px;
    }

    .col {
      flex: 1;
      display: flex;
      flex-direction: column;

      &:nth-child(2) {
        margin-left: 24px;
      }

      .tip {
        margin-bottom: 4px;
      }
    }
  }
}
</style>
